// Global activity indicator — any component can show/hide status messages
// Usage:
//   import { showActivity, hideActivity } from '../activity';
//   showActivity('Generating archive...');
//   hideActivity();

const listeners = new Set();

let currentMessage = null;

export function showActivity(message) {
  currentMessage = message;
  listeners.forEach(fn => fn(currentMessage));
}

export function hideActivity() {
  currentMessage = null;
  listeners.forEach(fn => fn(null));
}

export function subscribe(fn) {
  listeners.add(fn);
  // Send current state immediately
  fn(currentMessage);
  return () => listeners.delete(fn);
}